export const DIABETES_RECORDS = () => {
    return {
        DIABETES_QUESTION: {//section
            DIABETESQ1: {//QuestionsetCd
                DIABETESTYPEEELEMENT1: {//Dataelementcd
                    question: 'Please state the diagnosis relevant to you',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'When was the condition diagnosed or when did you first experience symptoms of high blood sugar?',
                    answer: ''
                }
            },
            DIABETESQ2: {
                YESNODATAELEMENT1: {
                    question: 'Do you test your own blood sugar at home?',
                    answer: ''
                }
            },
            DIABETESQ3: {
                FREETEXT1: {
                    question: 'Please provide details for the last 3 months',
                    answer: ''
                }
            },
            DIABETESQ4: {
                FREETEXT1: {
                    question: 'Frequency of Testing',
                    answer: ''
                },
                FREETEXT2: {
                    question: 'Lowest Result',
                    answer: ''
                },
                FREETEXT3: {
                    question: 'Highest Result',
                    answer: ''
                },
                FREETEXT4: {
                    question: 'Average Result',
                    answer: ''
                }
            },
            DIABETESQ5: {
                YESNODATAELEMENT1: {
                    question: 'Have you had a glycosylated haemoglobin test (HbA1c)?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details including the approximate date and result of your most recent test',
                    answer: ''
                }
            },
            DIABETESQ6: {
                FREETEXT1: {
                    question: 'Please provide details of any medication that you take in relation to your diabetes (please also include related medications such as those used to lower blood pressure and cholesterol)',
                    answer: ''
                },
                YESNODATAELEMENT1: {
                    question: 'Have you ever been admitted to hospital or required emergency care?',
                    answer: ''
                }
            },
            DIABETESQ7: {
                YESNODATAELEMENT1: {
                    question: 'Have you ever had Eye Problems?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details',
                    answer: ''
                }
            },
            DIABETESQ8: {
                YESNODATAELEMENT1: {
                    question: 'Have you ever had Heart Problems?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details',
                    answer: ''
                }
            },
            DIABETESQ9: {
                YESNODATAELEMENT1: {
                    question: 'Have you ever had High Blood Pressure?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details',
                    answer: ''
                }
            },
            DIABETESQ10: {
                YESNODATAELEMENT1: {
                    question: 'Have you ever had Kidney Problems (including protein in urine)?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details',
                    answer: ''
                }
            },
            DIABETESQ11: {
                YESNODATAELEMENT1: {
                    question: 'Have you ever had Sensory Problems (such as burning in your feet)?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details',
                    answer: ''
                }
            },
            DIABETESQ12: {
                YESNODATAELEMENT1: {
                    question: 'Any other complication?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details',
                    answer: ''
                }
            }, 
            DIABETESQ13: {
                FREETEXT1: {
                    question: 'Please provide the name and address of the doctors, specialists or clinics that you see in relation to your diabetes',
                    answer: ''
                }
            },
            DIABETESQ14: {
                FREETEXT1: {
                    question: 'Name of the doctor, hospital or clinic',
                    answer: ''
                },
                 FREETEXT2: {
                    question: 'Address',
                    answer: ''
                },
                DATEELEMENT1: {
                    question: 'Date of last consult',
                    answer: ''
                }
            },
            DIABETESQ15: {
                YESNODATAELEMENT1: {
                    question: 'Have you ever taken time off work because of your diabetes?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details (date & duration)',
                    answer: ''
                }
            },
            DIABETESQ16: {
                FREETEXT1: {
                    question: 'Please provide any additional information that you feel is important',
                    answer: ''
                }
            }
        }
    }
}